export const __CONFIG_KEY__ = '__config__'
export const __ROOT_NODE__ = 'root'
export const __I18N_KEY__ = '__i18n__'
